import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadCatalog } from './schemaLoader';

const getProductCode = (item) =>
  item?.productCode || item?.product_code || item?.code;

const normalizeMenuItem = (item) => {
  const menu = item?.menu || {};
  const productCode = getProductCode(item);

  if (!productCode) return null;

  return {
    key: menu.key || productCode,
    label: menu.label || item?.displayName || item?.display_name || productCode,
    route: menu.route || `/portal/invest/trade/${productCode}`,
    displayOrder: Number(menu.displayOrder ?? item?.displayOrder ?? 9999),
  };
};

const DynamicMenuSection = () => {
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    let isMounted = true;

    loadCatalog()
      .then((items) => {
        if (isMounted) {
          setCatalog(Array.isArray(items) ? items : []);
        }
      })
      .catch(() => {
        if (isMounted) {
          setCatalog([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const menuItems = useMemo(
    () =>
      catalog
        .map(normalizeMenuItem)
        .filter(Boolean)
        .sort((a, b) => a.displayOrder - b.displayOrder),
    [catalog]
  );

  if (menuItems.length === 0) return null;

  return (
    <>
      {menuItems.map((item) => (
        <li className="nk-menu-item" key={item.key}>
          <Link to={item.route} className="nk-menu-link">
            - <span className="nk-menu-text">{item.label} </span>
          </Link>
        </li>
      ))}
    </>
  );
};

export default DynamicMenuSection;
